import React from 'react';

export const DigitalAwarenessSection = () => {
  return (
    <section className="py-20 bg-gray-50 dark:bg-[#121212]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white">
            Dunia Bergerak Digital — Apakah Brand Anda Sudah Siap?
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 leading-relaxed">
            Saat ini, konsumen mencari, mempercayai, dan membeli secara online. Bisnis tanpa strategi digital yang kuat akan tertinggal. Kehadiran digital bukan lagi pilihan, tetapi kebutuhan.
          </p>
          <p className="text-xl font-semibold text-[#D32F2F]">
            Dreams Marketing hadir sebagai partner pertumbuhan digital Anda.
          </p>
        </div>
      </div>
    </section>
  );
};
